/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { setToken } from '../../utils/auth';
import { colors } from '../../utils/colors';
import { SetNewPasswordForm as DefSetNewPasswordForm } from '../../components/forms/SetNewPasswordForm';
import { Title, RouteLink, Text } from '../../components/texts';
import { AuthLayout } from '../../layouts';
import { paths } from '../paths';

const ResetPasswordPage = () => {
  const { t } = useTranslation();

  const [tokenAvailable, setTokenAvailable] = useState(false);

  const location = useLocation();

  const resetPasswordError = new URLSearchParams(location.search).get('error');
  const resetPasswordLinkExpired = resetPasswordError === 'expired';

  const errorMessage = resetPasswordLinkExpired
    ? 'RESET_PASSWORD_PAGE__expiredLink'
    : 'RESET_PASSWORD_PAGE__noToken';

  useLayoutEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const c = searchParams.get('c');

    if (resetPasswordLinkExpired || !c) {
      setTokenAvailable(false);
      return;
    }

    setToken(c);
    setTokenAvailable(true);
  }, [location.search, resetPasswordLinkExpired]);

  return (
    <AuthLayout>
      <Title withLine gutterBottom>
        {t('RESET_PASSWORD_PAGE__title')}
      </Title>
      {tokenAvailable ? (
        <SetNewPasswordForm />
      ) : (
        <Error>{t(errorMessage)}</Error>
      )}
      <BottomBlock>
        <BottomText>
          {t('RESET_PASSWORD_PAGE__loginText')}{' '}
          <RouteLink to={paths.login} underline={'always'}>
            {t('RESET_PASSWORD_PAGE__loginButtonText')}
          </RouteLink>
        </BottomText>
      </BottomBlock>
    </AuthLayout>
  );
};

const SetNewPasswordForm = styled(DefSetNewPasswordForm)`
  margin-bottom: 40px;
`;

const Error = styled(Text)`
  text-align: center;
  margin-bottom: 20px;
  color: ${colors.orange};
`;

const BottomBlock = styled.div``;

const BottomText = styled(Text)`
  text-align: center;
`;

export { ResetPasswordPage };

export default ResetPasswordPage;
